import { CollectorCoordinate, UniqueAllocation } from '@/src/types';

import { GameModel, gameModel } from '../models/game-model';

export enum CollectorState {
    Error = -1,
    Available,
    Allocated
}

export class CollectorService {
    public static get Instance(): CollectorService {
        return this._instance || (this._instance = new CollectorService());
    }
    private static _instance: CollectorService;

    public collectSymbol(_uniqueAllocation: UniqueAllocation): CollectorCoordinate {
        if (_uniqueAllocation === undefined) {
            console.warn('invalid symbolID call ');
            return;
        }

        if (_uniqueAllocation.allocatedSymbol > GameModel.NUMBER_OF_COLLECTORS - 1) {
            console.warn('invalid collector call');
            return;
        }

        if (_uniqueAllocation.goldenPrize) {
            gameModel.collectedStates[_uniqueAllocation.uniqueTicketID] = CollectorState.Allocated;
            gameModel.collectorStates[_uniqueAllocation.allocatedSymbol] = new Array(gameModel.collectorStates[_uniqueAllocation.allocatedSymbol].length).fill(CollectorState.Allocated);
            gameModel.invalidate(() => gameModel.collectorStates);
            return { collectorID: _uniqueAllocation.allocatedSymbol, cellID: 0 };
        }

        const allocationIndex = gameModel.collectorStates[_uniqueAllocation.allocatedSymbol].indexOf(CollectorState.Available);
        gameModel.collectorStates[_uniqueAllocation.allocatedSymbol][allocationIndex] = CollectorState.Allocated;
        gameModel.collectedStates[_uniqueAllocation.uniqueTicketID] = CollectorState.Allocated;
        gameModel.invalidate(() => gameModel.collectorStates);
        return { collectorID: _uniqueAllocation.allocatedSymbol, cellID: allocationIndex };
    }

    public isOneToGo(collectorState: number[]): boolean {
        const collectorAllocated: number = collectorState.reduce((count, state) => count + (state === CollectorState.Available ? CollectorState.Allocated : CollectorState.Available), CollectorState.Available);
        return collectorAllocated === CollectorState.Allocated ? true : false;
    }

    public isWin(collectorState: number[]): boolean {
        const collectorAllocated: number = collectorState.reduce((count, state) => count + (state === 0 ? CollectorState.Allocated : CollectorState.Available), CollectorState.Available);
        return collectorAllocated === CollectorState.Available ? true : false;
    }

    public toGoCount(collectorState: number[]): number {
        const collectorAllocated: number = collectorState.reduce((count, state) => count + (state === 0 ? CollectorState.Allocated : CollectorState.Available), CollectorState.Available);
        return collectorAllocated;
    }
}

export const collectorService = CollectorService.Instance;
